import { useEffect, useState } from "react";
import { Link, useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';


import * as React from 'react';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddBoxTwoToneIcon from '@mui/icons-material/AddBoxTwoTone';

const config = require("../constants/constants.js")

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));


const ProductCardComponent = ({ category, idx }) => {

  const url_image_elencoservizi = config.URL_IMAGES_CUSTOMER1 + "elenco-servizi-cat.png";
  const help_image_elencoservizi = "prodotti per " + category.name;
  const url_elencoservizi = "/product-list/category/" + category.name;

  let navigate = useNavigate();

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };


  return (

    <Card xs={4} md={4}
      elevation={6}
      sx={{
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#e9e9e9',
          opacity: [0.9, 0.8, 0.7],
        },
      }}
    >

      <Link to={url_elencoservizi}>
        <CardMedia
          component="img"
          image={category.images[0] ? category.images[0].path : ''}
          alt=""
          sx={{ width: 300, paddingTop: 2, paddingLeft: 2, paddingRight: 2 }}
        >
        </CardMedia>
      </Link>

      <CardContent
        sx={{
          width: '300px'
        }}
      >

        <Stack
          sx={{ flexDirection: { xs: "row", md: "row" } }}
        >
          <Box
            sx={{
              width: 270,
              maxHeight: { xs: 270, md: 270 },
              maxWidth: { xs: 270, md: 270 },
            }}
          >

            <Typography variant="body1"
              sx={{
                fontFamily: 'Arial',
                fontWeight: 700,
                fontSize: 20,
                color: 'text.primary',
              }}
            >
              {category.name}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Arial',
                fontWeight: 300,
                fontSize: 16,
                color: 'text.secondary',
              }}>
              {category.description}
            </Typography>
          </Box>

          <Box
            sx={{
              paddingTop: 1, paddingLeft: 0, paddingRight: 0,
              maxWidth: { xs: 30, md: 30 },
            }}
          >
            <Link to={url_elencoservizi}>
              <Tooltip title={help_image_elencoservizi} arrow placement="right-end">
                <Box
                  component="img"
                  sx={{
                    height: 25,
                    width: 25,
                    maxHeight: { xs: 25, md: 25 },
                    maxWidth: { xs: 25, md: 25 },
                  }}
                  src={url_image_elencoservizi}
                  onClick={() => {
                    navigate(url_elencoservizi)
                  }}
                >
                </Box>
              </Tooltip>

            </Link>
          </Box>
        </Stack>

        <Typography variant="body2"
          sx={{
            fontFamily: 'sans-serif',
            fontStyle: 'italic',
            fontWeight: 300,
            color: 'text.secondary',
            fontSize: 12,
            paddingTop: 1,
            paddingRight: 3,
          }}
        >
          {category.note}
        </Typography>

      </CardContent>

    </Card>

  );
};

export default ProductCardComponent;
